﻿import * as $ajax from './_ajax'
import * as $form from './_form'

export interface IInitOptions {
    pageName: string
    pagePrefix: string
}

let options: IInitOptions
let currentPage: number = 1
let currentSort: string
let currentSortAsc: boolean
let prevData: any = {}

export const init = ($options: IInitOptions): void => {
    options = $options

    $('.' + options.pagePrefix + '__pages').on('click change blur', () => {
        getList(1, currentSort, currentSortAsc)
    })

    $('.' + options.pagePrefix + '__onlyunread button').on('click', () => {
        getList(1, currentSort, currentSortAsc)
    })

    $('.' + options.pagePrefix + '__onlyofinterest button').on('click', () => {
        getList(1, currentSort, currentSortAsc)
    })

    getList(1, 'published', false)
}

export const reloadList = (): void => {
    if (!options || !options.pageName) return
    getList(currentPage, currentSort, currentSortAsc, true)
}

export const getList = (page: number, sort: string, sortasc: boolean, force = false): void => {
    const pages = $('.' + options.pagePrefix + '__pages').val()
    const unread = $form.getCheckboxlistValues($('.' + options.pagePrefix + '__onlyunread'))
    const ofinterest = $form.getCheckboxlistValues($('.' + options.pagePrefix + '__onlyofinterest'))

    currentPage = page
    currentSort = sort
    currentSortAsc = sortasc

    const data = {
        page,
        sort,
        sortasc,
        pages: pages,
        unread: unread.join(','),
        ofinterest: ofinterest.join(','),
    }

    // no need to do an ajax call if nothing's changed
    if (!force && JSON.stringify(data) === JSON.stringify(prevData)) {
        return
    }

    prevData = data

    $ajax.post({
        loadingText: 'Hämtar inlägg...',
        url: '/Blog/ListList',
        data,
        dataType: 'html',
        success: function (res: string) {
            if (!$ajax.okResponseHtml(res)) return

            $('.' + options.pageName + ' .' + options.pagePrefix + '__list').html(res)
        },
    })
}
